import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const usePrincipalGet = (principalId, skip = false) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v2/principal/${principalId}/`;
  return useRestQuery(requestUrl, { skip: !principalId || skip });
};

export default usePrincipalGet;
